module.exports = __webpack_public_path__ + "media/effects-20.a5467611.webm";